// 按讚、收藏、分享次數
'use client';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { newsState } from '@/slices/newsSlice';

const NewsSocialCount = () => {
    const { t } = useTranslation();
    const { newsSocialCount } = useSelector(newsState);

    return (
        <p className="ulg:hidden tabular-nums">
            {`${newsSocialCount?.thumb || 0} ${t('THUMB_UP')}・${newsSocialCount?.favorite} ${t(
                'COLLECT'
            )}・${newsSocialCount?.share} ${t('SHARE')}`}
        </p>
    );
};

export default NewsSocialCount;
